package uz.ferro.erp.feature.text.ui

import emotion.react.css
import react.FC
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import uz.ferro.erp.Colors
import uz.ferro.erp.feature.text.model.DocItemType
import uz.ferro.erp.feature.text.model.TextItem
import uz.ferro.erp.util.toIntOrZero
import web.cssom.Auto
import web.cssom.BorderStyle
import web.cssom.Length
import web.cssom.LineStyle
import web.cssom.em
import web.cssom.pct
import web.cssom.px

val DocImageView = FC<DocItemProps> { props ->
    val item = props.item

    img {
        css {
            maxWidth = if (item.maxWidth != null) {
                item.maxWidth.parseLength()
            } else {
                100.pct
            }

            width = if (item.width != null) {
                item.width.parseLength()
            } else {
                Auto.auto
            }

            height = if (item.height != null) {
                item.height.parseLength()
            } else {
                Auto.auto
            }
        }

        src = item.source
    }
}

private fun String.parseLength(): Length {
    if (endsWith("%")) {
        val value = removeSuffix("%").toIntOrZero()
        return value.pct
    }

    if (endsWith("px")) {
        val value = removeSuffix("px").toIntOrZero()
        return value.px
    }

    if (endsWith("em")) {
        val value = removeSuffix("em").toIntOrZero()
        return value.em
    }

    return 0.px
}